var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12L23 12M13 12L17 8M13 12L17 16",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.25C0.585786 3.25 0.25 3.58579 0.25 4C0.25 4.41421 0.585786 4.75 1 4.75L1 3.25ZM4.5 4V4.75V4ZM4.5 20V20.75V20ZM1 19.25C0.585787 19.25 0.250001 19.5858 0.250001 20C0.250001 20.4142 0.585787 20.75 1 20.75V19.25ZM1 4.75L4.5 4.75V3.25L1 3.25L1 4.75ZM4.5 19.25H1V20.75H4.5V19.25ZM4.5 4.75C5.08093 4.75 5.45008 4.93116 5.72052 5.20982C6.01448 5.51273 6.25001 5.9925 6.41823 6.6786C6.75928 8.06959 6.75 9.96116 6.75 12H8.25C8.25 10.0388 8.26959 7.93041 7.87508 6.3214C7.67552 5.50749 7.35215 4.73727 6.79695 4.16518C6.21822 3.56884 5.44794 3.25 4.5 3.25V4.75ZM6.75 12C6.75 14.0388 6.75928 15.9304 6.41823 17.3214C6.25001 18.0075 6.01448 18.4873 5.72052 18.7902C5.45008 19.0688 5.08093 19.25 4.5 19.25V20.75C5.44794 20.75 6.21823 20.4312 6.79695 19.8348C7.35215 19.2627 7.67552 18.4925 7.87508 17.6786C8.26959 16.0696 8.25 13.9612 8.25 12H6.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSide);
export default __webpack_public_path__ + "static/media/arrow-side.459582296b34b33a4991d9cbe9a38353.svg";
export { ForwardRef as ReactComponent };